module.exports = __webpack_public_path__ + "img/Skirt-Front-B7-Db-Fb-Hb-Ia.51e2594a.png";